import React from "react";

// Audio Icon
export const AudioIcon = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.29709 10.739V1.98901H5.26931V10.739H4.29709ZM6.24154 8.79457V3.93346H7.21376V8.79457H6.24154ZM2.35265 7.82235V4.90568H3.32487V7.82235H2.35265ZM8.18598 7.33624V5.39179H9.1582V7.33624H8.18598ZM0.408203 6.85012V5.8779H1.38043V6.85012H0.408203ZM8.91515 4.90568C8.90705 4.90568 8.87464 4.88137 8.81792 4.83276C8.6883 4.33855 8.44321 3.91118 8.08268 3.55064C7.72215 3.19011 7.29478 2.94503 6.80056 2.8154C6.78436 2.8073 6.76005 2.77489 6.72765 2.71818C6.72765 2.70198 6.75195 2.66957 6.80056 2.62096C7.29478 2.49133 7.72215 2.24625 8.08268 1.88571C8.44321 1.52518 8.6883 1.09781 8.81792 0.603596C8.82603 0.587393 8.85843 0.563087 8.91515 0.53068C8.93135 0.53068 8.96376 0.554985 9.01237 0.603596C9.1501 1.09781 9.39721 1.52518 9.75369 1.88571C10.1102 2.24625 10.5355 2.49133 11.0297 2.62096C11.0459 2.62096 11.0702 2.65337 11.1026 2.71818C11.1026 2.72628 11.0783 2.75869 11.0297 2.8154C10.5355 2.94503 10.1081 3.19011 9.74761 3.55064C9.38708 3.91118 9.142 4.33855 9.01237 4.83276C9.01237 4.84897 8.97996 4.87327 8.91515 4.90568Z"
      fill="#F05203"
    />
  </svg>
);

// Quiz Icon
export const QuizIcon = () => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.48958 6.39654C6.62731 6.39654 6.74682 6.3459 6.84809 6.24463C6.94936 6.14336 7 6.02385 7 5.88612C7 5.74839 6.94936 5.62889 6.84809 5.52762C6.74682 5.42634 6.62731 5.37571 6.48958 5.37571C6.35185 5.37571 6.23235 5.42634 6.13108 5.52762C6.0298 5.62889 5.97917 5.74839 5.97917 5.88612C5.97917 6.02385 6.0298 6.14336 6.13108 6.24463C6.23235 6.3459 6.35185 6.39654 6.48958 6.39654ZM6.125 4.84098H6.85417C6.85417 4.60603 6.87847 4.43387 6.92708 4.32449C6.97569 4.21512 7.08912 4.07131 7.26736 3.89307C7.51042 3.65001 7.67245 3.45354 7.75347 3.30366C7.83449 3.15377 7.875 2.97756 7.875 2.77501C7.875 2.41043 7.7474 2.11268 7.49219 1.88178C7.23698 1.65088 6.90278 1.53543 6.48958 1.53543C6.15741 1.53543 5.86777 1.6286 5.62066 1.81494C5.37355 2.00128 5.20139 2.24839 5.10417 2.55626L5.76042 2.82362C5.83333 2.62108 5.93258 2.46917 6.05816 2.36789C6.18374 2.26662 6.32755 2.21598 6.48958 2.21598C6.68403 2.21598 6.84201 2.27067 6.96354 2.38005C7.08507 2.48942 7.14583 2.63728 7.14583 2.82362C7.14583 2.93705 7.11343 3.0444 7.04861 3.14567C6.9838 3.24694 6.87037 3.37455 6.70833 3.52848C6.44097 3.76344 6.27691 3.94775 6.21615 4.08143C6.15538 4.21512 6.125 4.4683 6.125 4.84098ZM3.57292 7.85487C3.30556 7.85487 3.07668 7.75968 2.88628 7.56928C2.69589 7.37889 2.60069 7.15001 2.60069 6.88265V1.04932C2.60069 0.781955 2.69589 0.553078 2.88628 0.362684C3.07668 0.172291 3.30556 0.0770941 3.57292 0.0770941H9.40625C9.67361 0.0770941 9.90249 0.172291 10.0929 0.362684C10.2833 0.553078 10.3785 0.781955 10.3785 1.04932V6.88265C10.3785 7.15001 10.2833 7.37889 10.0929 7.56928C9.90249 7.75968 9.67361 7.85487 9.40625 7.85487H3.57292ZM3.57292 6.88265H9.40625V1.04932H3.57292V6.88265ZM1.62847 9.79932C1.36111 9.79932 1.13223 9.70412 0.94184 9.51373C0.751447 9.32333 0.65625 9.09446 0.65625 8.82709V2.02154H1.62847V8.82709H8.43403V9.79932H1.62847Z"
      fill="#F05203"
    />
  </svg>
);

export const TextFileIcon = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 0.5H7.5L10 3V9.5C10 9.77614 9.77614 10 9.5 10H2.5C2.22386 10 2 9.77614 2 9.5V0.5Z"
      stroke="#F05203"
      strokeWidth="0.8"
      fill="none"
    />
    <path d="M7.5 0.5V3H10" stroke="#F05203" strokeWidth="0.8" fill="none" />
    <path
      d="M3.5 4.5H8.5"
      stroke="#F05203"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <path
      d="M3.5 6H7.5"
      stroke="#F05203"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <path
      d="M3.5 7.5H6"
      stroke="#F05203"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
  </svg>
);

// Flashcards Icon
export const FlashcardsIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.62681 6.0116L6.73271 5.3432L7.83861 6.0116L7.54695 4.74771L8.51917 3.90917L7.24313 3.7998L6.73271 2.60883L6.22229 3.7998L4.94625 3.90917L5.91847 4.74771L5.62681 6.0116ZM5.85771 9.17133H8.57993C8.52322 9.38197 8.426 9.55211 8.28827 9.68174C8.15053 9.81137 7.97229 9.89239 7.75354 9.9248L2.45493 10.5689C2.18757 10.6094 1.94654 10.5466 1.73184 10.3805C1.51714 10.2144 1.39359 9.99772 1.36118 9.73035L0.717086 4.41959C0.684679 4.15223 0.749494 3.91322 0.911531 3.70258C1.07357 3.49193 1.28827 3.3704 1.55563 3.33799L2.11466 3.26508V4.2373L1.67716 4.29806L2.33341 9.60883L5.85771 9.17133ZM4.0591 8.1991C3.79174 8.1991 3.56286 8.10391 3.37247 7.91351C3.18207 7.72312 3.08688 7.49424 3.08688 7.22688V1.87966C3.08688 1.6123 3.18207 1.38342 3.37247 1.19303C3.56286 1.00263 3.79174 0.907436 4.0591 0.907436H9.40632C9.67368 0.907436 9.90256 1.00263 10.093 1.19303C10.2833 1.38342 10.3785 1.6123 10.3785 1.87966V7.22688C10.3785 7.49424 10.2833 7.72312 10.093 7.91351C9.90256 8.10391 9.67368 8.1991 9.40632 8.1991H4.0591ZM4.0591 7.22688H9.40632V1.87966H4.0591V7.22688Z"
      fill="#F05203"
    />
  </svg>
);

// Mindmap Icon
export const MindmapIcon = () => (
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.63626 8.85962V7.81462H5.54626V5.20211H4.50126V6.24712H0.84375V3.11211H4.50126V4.15711H5.54626V1.54461H7.63626V0.499606H11.2938V3.63461H7.63626V2.58961H6.59126V6.76962H7.63626V5.72461H11.2938V8.85962H7.63626ZM8.68126 7.81462H10.2488V6.76962H8.68126V7.81462ZM1.88875 5.20211H3.45625V4.15711H1.88875V5.20211ZM8.68126 2.58961H10.2488V1.54461H8.68126V2.58961Z"
      fill="#F05203"
    />
  </svg>
);

// Left Toggle Icon
export const LeftToggleIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.24522 13.4289C1.84612 13.4289 1.50446 13.2868 1.22026 13.0026C0.936049 12.7184 0.793945 12.3767 0.793945 11.9776V1.81872C0.793945 1.41963 0.936049 1.07797 1.22026 0.793764C1.50446 0.509557 1.84612 0.367454 2.24522 0.367454H12.4041C12.8032 0.367454 13.1449 0.509557 13.4291 0.793764C13.7133 1.07797 13.8554 1.41963 13.8554 1.81872V11.9776C13.8554 12.3767 13.7133 12.7184 13.4291 13.0026C13.1449 13.2868 12.8032 13.4289 12.4041 13.4289H2.24522ZM10.2272 11.9776H12.4041V1.81872H10.2272V11.9776ZM8.77594 11.9776V1.81872H2.24522V11.9776H8.77594Z"
      fill="#F05203"
    />
  </svg>
);

// PDF Icon
export const PdfIcon = () => (
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6622 5.67862C12.419 5.46685 12.0347 5.26293 11.4622 5.26293H9.21511C9.21511 5.26293 8.22687 5.22763 8.22687 4.07077V2.02371C8.22687 2.02371 8.08962 1.20411 7.81903 0.968812C7.77589 0.933518 7.77197 0.909988 7.79158 0.906067C7.78766 0.906067 7.78374 0.909988 7.78374 0.909988L12.6622 5.62371V5.67469V5.67862ZM7.87785 0.909988C7.88962 0.91391 7.89746 0.91391 7.90923 0.917832C7.89746 0.91391 7.8857 0.91391 7.87785 0.909988ZM8.11315 0.98842C8.12883 0.996263 8.14844 1.00411 8.16805 1.01195C8.14844 1.00411 8.13276 0.996263 8.11315 0.98842Z"
      fill="url(#paint0_linear_8197_1785)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.42683 0.698242H1.92879C1.368 0.698242 0.90918 1.15707 0.90918 1.71785V15.5296C0.90918 16.0865 1.35624 16.5375 1.90918 16.5492H4.51702H3.27781H11.9876C12.5484 16.5492 13.0072 16.0904 13.0072 15.5296V7.25118C13.0072 5.71785 11.6817 5.65118 11.6817 5.65118H9.16408C7.83859 5.65118 7.86996 4.2904 7.86996 4.2904V2.21589C7.86996 0.647262 6.43859 0.71785 6.43859 0.71785L6.43075 0.710007L6.42683 0.698242ZM12.67 5.67863C12.4268 5.46295 12.0425 5.26295 11.47 5.26295H9.22291C9.22291 5.26295 8.23467 5.22765 8.23467 4.07079V2.02373C8.23467 2.02373 8.09742 1.20412 7.82683 0.96883C7.79545 0.941379 7.78369 0.921772 7.79153 0.910007L12.666 5.61981V5.56883C11.3955 3.64726 10.3366 2.69824 9.59153 1.95314C9.23467 1.59628 8.79938 1.31785 8.44643 1.13746C8.8033 1.31785 9.23859 1.59628 9.59938 1.95707C10.3445 2.70216 11.4033 3.65118 12.6739 5.57275V5.67863H12.67Z"
      fill="#E31E24"
    />
    <path
      d="M3.17188 8.70999H4.55619C4.85815 8.70999 5.08168 8.78058 5.23462 8.92568C5.38756 9.07078 5.45815 9.27078 5.45815 9.53744C5.45815 9.80803 5.37187 10.0198 5.21109 10.1727C5.04638 10.3257 4.79933 10.4041 4.46207 10.4041H4.00717V11.4002H3.17188V8.71391V8.70999ZM4.00717 9.85901H4.21109C4.3758 9.85901 4.48168 9.82764 4.54835 9.77274C4.61501 9.71783 4.64638 9.64725 4.64638 9.56097C4.64638 9.4747 4.61501 9.40411 4.56011 9.34529C4.50521 9.28646 4.3954 9.25509 4.23854 9.25509H4.00325V9.85901H4.00717ZM5.89737 8.70999H7.12874C7.37187 8.70999 7.56795 8.74136 7.72089 8.80803C7.87384 8.8747 7.99148 8.97274 8.09344 9.09038C8.19148 9.21587 8.26207 9.35705 8.30521 9.51783C8.34835 9.68254 8.37187 9.85509 8.37187 10.0355C8.37187 10.3257 8.3405 10.5414 8.27384 10.7061C8.20717 10.8629 8.11697 10.9963 8.00325 11.1061C7.88952 11.2159 7.76011 11.2865 7.62678 11.3178C7.44638 11.3649 7.28168 11.3884 7.13266 11.3884H5.90129V8.70215L5.89344 8.70999H5.89737ZM6.72482 9.32176V10.7884H6.92874C7.10521 10.7884 7.22286 10.7688 7.30521 10.7296C7.3758 10.6943 7.43854 10.6198 7.48168 10.5296C7.52482 10.4316 7.5405 10.2747 7.5405 10.0629C7.5405 9.78058 7.49344 9.5845 7.40325 9.47862C7.31305 9.37666 7.15619 9.32176 6.93658 9.32176H6.73266H6.72482ZM8.80717 8.70999H10.8621V9.29038H9.64246V9.76097H10.6856V10.3061H9.64246V11.4002H8.80717V8.71391V8.70999Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8197_1785"
        x1="11.9527"
        y1="0.815126"
        x2="8.48334"
        y2="5.76567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A42421" />
        <stop offset="1" stop-color="#E31E24" />
      </linearGradient>
    </defs>
  </svg>
);

// Doc Icon
export const DocIcon = () => (
  <svg
    width="13"
    height="18"
    viewBox="0 0 13 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.2867 0.102173H7.97476L12.7897 5.12564V14.8907C12.7897 16.1122 11.7996 17.1022 10.5782 17.1022H2.2867C1.0652 17.1022 0.0751953 16.1121 0.0751953 14.8907V2.31368C0.0751953 1.0922 1.0652 0.102173 2.2867 0.102173Z"
      fill="#0263D1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.96777 0.102173V5.08437H12.7896L7.96777 0.102173Z"
      fill="#0A53A7"
    />
    <path
      d="M2.12891 12.2323V9.41802H3.12581C3.32518 9.41802 3.51083 9.44781 3.68271 9.50282C3.85459 9.5601 4.01042 9.6426 4.15023 9.75262C4.29002 9.86262 4.40004 10.0093 4.48024 10.1926C4.56045 10.376 4.60171 10.5868 4.60171 10.8251C4.60171 11.0635 4.56045 11.2743 4.48024 11.4576C4.40004 11.641 4.29002 11.7876 4.15023 11.8976C4.01044 12.0076 3.85459 12.0901 3.68271 12.1475C3.51083 12.2025 3.3252 12.2323 3.12581 12.2323H2.12891ZM2.83247 11.6204H3.04101C3.1533 11.6204 3.25873 11.6066 3.35268 11.5814C3.44893 11.5539 3.536 11.5104 3.61851 11.4531C3.70101 11.3958 3.76517 11.3133 3.81101 11.2056C3.85914 11.1001 3.88204 10.9718 3.88204 10.8251C3.88204 10.6785 3.85912 10.5501 3.81101 10.4424C3.76517 10.337 3.70101 10.2545 3.61851 10.1972C3.536 10.1376 3.44893 10.0964 3.35268 10.0689C3.25873 10.0436 3.1533 10.0299 3.04101 10.0299H2.83247V11.6204ZM6.30902 12.2643C5.88506 12.2643 5.53443 12.1268 5.25713 11.8541C4.97983 11.5814 4.84232 11.2376 4.84232 10.8252C4.84232 10.4126 4.97983 10.0689 5.25713 9.79618C5.53443 9.52346 5.88506 9.38597 6.30902 9.38597C6.72611 9.38597 7.07217 9.52348 7.34947 9.79618C7.62447 10.0689 7.76198 10.4127 7.76198 10.8252C7.76198 11.2376 7.62447 11.5814 7.34947 11.8541C7.07217 12.1268 6.72611 12.2643 6.30902 12.2643ZM5.76817 11.4187C5.90796 11.5745 6.08671 11.6525 6.30443 11.6525C6.52214 11.6525 6.6986 11.5745 6.83841 11.4187C6.97819 11.2606 7.04695 11.0635 7.04695 10.8251C7.04695 10.5868 6.97819 10.3897 6.83841 10.2316C6.69862 10.0757 6.52214 9.99781 6.30443 9.99781C6.08671 9.99781 5.90796 10.0757 5.76817 10.2316C5.62838 10.3897 5.55733 10.5868 5.55733 10.8251C5.55733 11.0635 5.62838 11.2606 5.76817 11.4187ZM9.43493 12.2643C9.02471 12.2643 8.68323 12.136 8.41283 11.8839C8.1401 11.6295 8.00491 11.2766 8.00491 10.8251C8.00491 10.376 8.14242 10.023 8.41742 9.76865C8.69472 9.51426 9.03161 9.38593 9.43495 9.38593C9.79933 9.38593 10.0972 9.4753 10.3333 9.65635C10.5671 9.8351 10.7023 10.0734 10.7366 10.3714L10.0262 10.5157C9.99642 10.3599 9.92537 10.2339 9.81537 10.1399C9.70538 10.0459 9.57704 9.99781 9.43035 9.99781C9.22868 9.99781 9.06138 10.0689 8.92617 10.2132C8.79095 10.3599 8.7222 10.5616 8.7222 10.8251C8.7222 11.0887 8.79095 11.2903 8.92387 11.4347C9.05908 11.5814 9.22638 11.6524 9.43033 11.6524C9.57699 11.6524 9.70306 11.6112 9.80618 11.5287C9.9093 11.4462 9.97348 11.3362 10.001 11.1987L10.7275 11.3637C10.661 11.6479 10.5143 11.8679 10.2851 12.026C10.0583 12.1841 9.77411 12.2643 9.43493 12.2643Z"
      fill="white"
    />
  </svg>
);

// Right Toggle Icon
export const RightToggleIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.24522 13.4289C1.84612 13.4289 1.50446 13.2868 1.22026 13.0026C0.936049 12.7184 0.793945 12.3767 0.793945 11.9776V1.81872C0.793945 1.41963 0.936049 1.07797 1.22026 0.793764C1.50446 0.509557 1.84612 0.367454 2.24522 0.367454H12.4041C12.8032 0.367454 13.1449 0.509557 13.4291 0.793764C13.7133 1.07797 13.8554 1.41963 13.8554 1.81872V11.9776C13.8554 12.3767 13.7133 12.7184 13.4291 13.0026C13.1449 13.2868 12.8032 13.4289 12.4041 13.4289H2.24522ZM10.2272 11.9776H12.4041V1.81872H10.2272V11.9776ZM8.77594 11.9776V1.81872H2.24522V11.9776H8.77594Z"
      fill="#82BD00"
    />
  </svg>
);

// Close Icon
export const CloseIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3262 22.8983C20.3262 21.2415 21.6693 19.8983 23.3262 19.8983H25.3262C25.8785 19.8983 26.3262 20.346 26.3262 20.8983C26.3262 21.4506 25.8785 21.8983 25.3262 21.8983H23.3262C22.7739 21.8983 22.3262 22.346 22.3262 22.8983V24.8983C22.3262 25.4506 21.8785 25.8983 21.3262 25.8983C20.7739 25.8983 20.3262 25.4506 20.3262 24.8983V22.8983Z"
      fill="#82BD00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3262 8.89832C20.3262 10.5552 21.6693 11.8983 23.3262 11.8983H25.3262C25.8785 11.8983 26.3262 11.4506 26.3262 10.8983C26.3262 10.346 25.8785 9.89832 25.3262 9.89832H23.3262C22.7739 9.89832 22.3262 9.4506 22.3262 8.89832V6.89832C22.3262 6.34603 21.8785 5.89832 21.3262 5.89832C20.7739 5.89832 20.3262 6.34603 20.3262 6.89832V8.89832Z"
      fill="#82BD00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3262 8.89832C12.3262 10.5552 10.983 11.8983 9.32617 11.8983H7.32617C6.77389 11.8983 6.32617 11.4506 6.32617 10.8983C6.32617 10.346 6.77389 9.89832 7.32617 9.89832H9.32617C9.87846 9.89832 10.3262 9.4506 10.3262 8.89832V6.89832C10.3262 6.34603 10.7739 5.89832 11.3262 5.89832C11.8785 5.89832 12.3262 6.34603 12.3262 6.89832V8.89832Z"
      fill="#82BD00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3262 22.8983C12.3262 21.2415 10.983 19.8983 9.32617 19.8983H7.32617C6.77389 19.8983 6.32617 20.346 6.32617 20.8983C6.32617 21.4506 6.77389 21.8983 7.32617 21.8983H9.32617C9.87846 21.8983 10.3262 22.346 10.3262 22.8983V24.8983C10.3262 25.4506 10.7739 25.8983 11.3262 25.8983C11.8785 25.8983 12.3262 25.4506 12.3262 24.8983V22.8983Z"
      fill="#82BD00"
    />
  </svg>
);

// Audio Overview Icon
export const AudioOverviewIcon = () => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.19057 18.0803V2.84197H8.88372V18.0803H7.19057ZM10.5769 14.694V6.22827H12.27V14.694H10.5769ZM3.80427 13.0009V7.92142H5.49742V13.0009H3.80427ZM13.9632 12.1543V8.768H15.6563V12.1543H13.9632ZM0.417969 11.3077V9.61457H2.11112V11.3077H0.417969ZM15.233 7.92142C15.2189 7.92142 15.1625 7.8791 15.0637 7.79444C14.838 6.93375 14.4111 6.18947 13.7833 5.5616C13.1554 4.93372 12.4111 4.5069 11.5504 4.28115C11.5222 4.26704 11.4799 4.2106 11.4234 4.11184C11.4234 4.08362 11.4658 4.02718 11.5504 3.94252C12.4111 3.71677 13.1554 3.28995 13.7833 2.66208C14.4111 2.0342 14.838 1.28992 15.0637 0.429235C15.0778 0.401016 15.1343 0.358688 15.233 0.30225C15.2612 0.30225 15.3177 0.344578 15.4023 0.429235C15.6422 1.28992 16.0725 2.0342 16.6934 2.66208C17.3142 3.28995 18.0549 3.71677 18.9156 3.94252C18.9438 3.94252 18.9862 3.99896 19.0426 4.11184C19.0426 4.12595 19.0003 4.18238 18.9156 4.28115C18.0549 4.5069 17.3107 4.93372 16.6828 5.5616C16.0549 6.18947 15.6281 6.93375 15.4023 7.79444C15.4023 7.82266 15.3459 7.86499 15.233 7.92142Z"
      fill="white"
    />
  </svg>
);

// Mindmap Overview Icon
export const MindmapOverviewIcon = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8023 14.3723V12.6792H8.41605V8.44629H6.7229V10.1394H0.796875V5.05999H6.7229V6.75314H8.41605V2.52027H11.8023V0.827117H17.7284V5.90657H11.8023V4.21342H10.1092V10.986H11.8023V9.29287H17.7284V14.3723H11.8023ZM13.4955 12.6792H16.0352V10.986H13.4955V12.6792ZM2.49002 8.44629H5.02975V6.75314H2.49002V8.44629ZM13.4955 4.21342H16.0352V2.52027H13.4955V4.21342Z"
      fill="white"
    />
  </svg>
);

// Flashcards Overview Icon
export const FlashcardsOverviewIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.95319 9.52296L10.8791 8.35892L12.8051 9.52296L12.2972 7.32186L13.9903 5.86152L11.768 5.67104L10.8791 3.59693L9.99024 5.67104L7.76798 5.86152L9.46113 7.32186L8.95319 9.52296ZM9.35531 15.0257H14.0961C13.9974 15.3925 13.828 15.6888 13.5882 15.9146C13.3483 16.1404 13.0379 16.2814 12.657 16.3379L3.42929 17.4596C2.96367 17.5301 2.54391 17.4208 2.17001 17.1315C1.7961 16.8423 1.58093 16.4649 1.52449 15.9993L0.402781 6.75043C0.346343 6.28481 0.45922 5.86858 0.741411 5.50173C1.0236 5.13488 1.39751 4.92323 1.86312 4.8668L2.83668 4.73981V6.43296L2.07477 6.53878L3.21764 15.7876L9.35531 15.0257ZM6.22298 13.3325C5.75737 13.3325 5.35877 13.1668 5.0272 12.8352C4.69562 12.5036 4.52983 12.105 4.52983 11.6394V2.32707C4.52983 1.86145 4.69562 1.46286 5.0272 1.13128C5.35877 0.799707 5.75737 0.633921 6.22298 0.633921H15.5353C16.0009 0.633921 16.3995 0.799707 16.7311 1.13128C17.0627 1.46286 17.2285 1.86145 17.2285 2.32707V11.6394C17.2285 12.105 17.0627 12.5036 16.7311 12.8352C16.3995 13.1668 16.0009 13.3325 15.5353 13.3325H6.22298ZM6.22298 11.6394H15.5353V2.32707H6.22298V11.6394Z"
      fill="white"
    />
  </svg>
);

// Quiz Overview Icon
export const QuizOverviewIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9577 11.6394C11.1976 11.6394 11.4057 11.5512 11.5821 11.3749C11.7584 11.1985 11.8466 10.9904 11.8466 10.7505C11.8466 10.5106 11.7584 10.3025 11.5821 10.1262C11.4057 9.94978 11.1976 9.8616 10.9577 9.8616C10.7179 9.8616 10.5097 9.94978 10.3334 10.1262C10.157 10.3025 10.0688 10.5106 10.0688 10.7505C10.0688 10.9904 10.157 11.1985 10.3334 11.3749C10.5097 11.5512 10.7179 11.6394 10.9577 11.6394ZM10.3228 8.93037H11.5927C11.5927 8.52119 11.635 8.22136 11.7196 8.03088C11.8043 7.8404 12.0018 7.58996 12.3122 7.27954C12.7355 6.85626 13.0177 6.5141 13.1588 6.25307C13.2999 5.99205 13.3705 5.68516 13.3705 5.33242C13.3705 4.69749 13.1482 4.17896 12.7038 3.77684C12.2593 3.37472 11.6773 3.17366 10.9577 3.17366C10.3792 3.17366 9.87482 3.33592 9.44447 3.66044C9.01413 3.98496 8.7143 4.4153 8.54499 4.95146L9.68786 5.41708C9.81485 5.06434 9.98769 4.79979 10.2064 4.62342C10.4251 4.44705 10.6755 4.35886 10.9577 4.35886C11.2964 4.35886 11.5715 4.4541 11.7831 4.64458C11.9948 4.83506 12.1006 5.09256 12.1006 5.41708C12.1006 5.61461 12.0442 5.80157 11.9313 5.97794C11.8184 6.15431 11.6209 6.37653 11.3387 6.64461C10.8731 7.05379 10.5874 7.37478 10.4815 7.60759C10.3757 7.8404 10.3228 8.28133 10.3228 8.93037ZM5.87828 14.1791C5.41266 14.1791 5.01407 14.0133 4.68249 13.6818C4.35092 13.3502 4.18513 12.9516 4.18513 12.486V2.32708C4.18513 1.86147 4.35092 1.46287 4.68249 1.13129C5.01407 0.799719 5.41266 0.633932 5.87828 0.633932H16.0372C16.5028 0.633932 16.9014 0.799719 17.233 1.13129C17.5645 1.46287 17.7303 1.86147 17.7303 2.32708V12.486C17.7303 12.9516 17.5645 13.3502 17.233 13.6818C16.9014 14.0133 16.5028 14.1791 16.0372 14.1791H5.87828ZM5.87828 12.486H16.0372V2.32708H5.87828V12.486ZM2.49198 17.5654C2.02636 17.5654 1.62777 17.3996 1.29619 17.0681C0.964616 16.7365 0.798828 16.3379 0.798828 15.8723V4.02023H2.49198V15.8723H14.344V17.5654H2.49198Z"
      fill="white"
    />
  </svg>
);

// Bot Icon
export const BotIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9.81814V6.84314C19 6.31271 18.7893 5.804 18.4142 5.42893C18.0391 5.05386 17.5304 4.84314 17 4.84314H11V3.53114C11.305 3.25714 11.5 2.86314 11.5 2.42114C11.5 2.02332 11.342 1.64179 11.0607 1.36048C10.7794 1.07918 10.3978 0.921143 10 0.921143C9.60218 0.921143 9.22064 1.07918 8.93934 1.36048C8.65804 1.64179 8.5 2.02332 8.5 2.42114C8.5 2.86314 8.695 3.25714 9 3.53114V4.84314H3C2.46957 4.84314 1.96086 5.05386 1.58579 5.42893C1.21071 5.804 1 6.31271 1 6.84314V9.84114L0.928 9.84614C0.675973 9.86434 0.440176 9.97726 0.268018 10.1622C0.0958586 10.3472 0.000102245 10.5905 0 10.8431V12.8431C0 13.1084 0.105357 13.3627 0.292893 13.5502C0.48043 13.7378 0.734784 13.8431 1 13.8431V18.8431C1 19.3736 1.21071 19.8823 1.58579 20.2574C1.96086 20.6324 2.46957 20.8431 3 20.8431H17C17.5304 20.8431 18.0391 20.6324 18.4142 20.2574C18.7893 19.8823 19 19.3736 19 18.8431V13.8431C19.2652 13.8431 19.5196 13.7378 19.7071 13.5502C19.8946 13.3627 20 13.1084 20 12.8431V10.9051C20.0117 10.7499 19.9871 10.5941 19.928 10.4501C19.726 9.96214 19.293 9.84514 19 9.81814ZM5 10.8431C5 9.73914 5.672 8.84314 6.5 8.84314C7.328 8.84314 8 9.73914 8 10.8431C8 11.9471 7.328 12.8431 6.5 12.8431C5.672 12.8431 5 11.9471 5 10.8431ZM13.998 16.8431C12.997 16.8401 6 16.8431 6 16.8431V14.8431C6 14.8431 13.001 14.8411 14.002 14.8431L13.998 16.8431ZM13.5 12.8431C12.672 12.8431 12 11.9471 12 10.8431C12 9.73914 12.672 8.84314 13.5 8.84314C14.328 8.84314 15 9.73914 15 10.8431C15 11.9471 14.328 12.8431 13.5 12.8431Z"
      fill="white"
    />
  </svg>
);

// Send Icon
export const SendIcon = () => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0615234 14.0924V0.54721L16.1464 7.31981L0.0615234 14.0924ZM1.75467 11.5527L11.7866 7.31981L1.75467 3.08693V6.04995L6.83412 7.31981L1.75467 8.58967V11.5527ZM1.75467 11.5527V7.31981V3.08693V6.04995V8.58967V11.5527Z"
      fill="white"
    />
  </svg>
);

// Audio Play Icon
export const AudioPlayIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_8110_13611"
      maskType="luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="23"
      height="23"
    >
      <path
        d="M11.8652 21.5381C17.3882 21.5381 21.8652 17.0611 21.8652 11.5381C21.8652 6.01509 17.3882 1.53809 11.8652 1.53809C6.34223 1.53809 1.86523 6.01509 1.86523 11.5381C1.86523 17.0611 6.34223 21.5381 11.8652 21.5381Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M9.86523 11.5381V8.0741L12.8652 9.8061L15.8652 11.5381L12.8652 13.2701L9.86523 15.0021V11.5381Z"
        fill="black"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </mask>
    <g mask="url(#mask0_8110_13611)">
      <path
        d="M-0.134766 -0.461914H23.8652V23.5381H-0.134766V-0.461914Z"
        fill="#82BD00"
      />
    </g>
  </svg>
);

// Add Note Icon
export const AddNoteIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.07236 12.5512H3.1064L10.1995 5.45808L9.16545 4.42405L2.07236 11.5171V12.5512ZM0.621094 14.0024V10.9185L10.1995 1.35824C10.3446 1.22521 10.5049 1.12241 10.6802 1.04985C10.8556 0.977283 11.04 0.941001 11.2335 0.941001C11.427 0.941001 11.6145 0.977283 11.7959 1.04985C11.9773 1.12241 12.1345 1.23125 12.2675 1.37638L13.2653 2.39227C13.4104 2.5253 13.5162 2.68253 13.5828 2.86394C13.6493 3.04534 13.6825 3.22675 13.6825 3.40816C13.6825 3.60166 13.6493 3.7861 13.5828 3.96146C13.5162 4.13682 13.4104 4.29707 13.2653 4.44219L3.70504 14.0024H0.621094ZM9.6734 4.95014L9.16545 4.42405L10.1995 5.45808L9.6734 4.95014Z"
      fill="white"
    />
  </svg>
);

// Prev Button Icon
export const PrevButtonIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2792 7.8298H1.44922M1.44922 7.8298L7.76046 1.51855M1.44922 7.8298L7.76046 14.141"
      stroke="#82BD00"
      strokeWidth="2.10375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Next Button Icon
export const NextButtonIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.85946 7.82992H18.6895M18.6895 7.82992L12.3782 1.51868M18.6895 7.82992L12.3782 14.1412"
      stroke="#82BD00"
      strokeWidth="2.10375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Chevron Down Icon
export const ChevronDown = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill={color}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
    />
  </svg>
);

// Chevron Down Icon
export const ChevronUp = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill={color}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
    />
  </svg>
);

// Chevron Right Icon
export const ChevronRight = ({ color = "#fff" }) => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 1L6.5 6L1.5 11"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Pause Fill Icon
export const PauseFill = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill={color}
    viewBox="0 0 16 16"
  >
    <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5" />
  </svg>
);

// Play Fill Icon
export const PlayFill = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill={color}
    viewBox="0 0 16 16"
  >
    <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393" />
  </svg>
);

// Stop Fill Icon
export const StopFill = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill={color}
    viewBox="0 0 16 16"
  >
    <path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5" />
  </svg>
);

// File Text Fill Icon
export const FileTextFill = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill={color}
    viewBox="0 0 16 16"
  >
    <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1" />
  </svg>
);

// File Text Icon
export const FileText = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    viewBox="0 0 16 16"
  >
    <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z" />
    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1" />
  </svg>
);

// Calendar Icon
export const Calendar = ({ color = "#fff" }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.4">
      <path
        opacity="0.7"
        d="M19.3164 4.578H17.3164V3.578C17.3164 3.31279 17.2111 3.05843 17.0235 2.8709C16.836 2.68336 16.5816 2.578 16.3164 2.578C16.0512 2.578 15.7968 2.68336 15.6093 2.8709C15.4218 3.05843 15.3164 3.31279 15.3164 3.578V4.578H9.31641V3.578C9.31641 3.31279 9.21105 3.05843 9.02351 2.8709C8.83598 2.68336 8.58162 2.578 8.31641 2.578C8.05119 2.578 7.79684 2.68336 7.6093 2.8709C7.42176 3.05843 7.31641 3.31279 7.31641 3.578V4.578H5.31641C4.52076 4.578 3.7577 4.89407 3.19509 5.45668C2.63248 6.01929 2.31641 6.78235 2.31641 7.578V19.578C2.31641 20.3737 2.63248 21.1367 3.19509 21.6993C3.7577 22.2619 4.52076 22.578 5.31641 22.578H19.3164C20.1121 22.578 20.8751 22.2619 21.4377 21.6993C22.0003 21.1367 22.3164 20.3737 22.3164 19.578V7.578C22.3164 6.78235 22.0003 6.01929 21.4377 5.45668C20.8751 4.89407 20.1121 4.578 19.3164 4.578ZM20.3164 19.578C20.3164 19.8432 20.2111 20.0976 20.0235 20.2851C19.836 20.4726 19.5816 20.578 19.3164 20.578H5.31641C5.05119 20.578 4.79684 20.4726 4.6093 20.2851C4.42176 20.0976 4.31641 19.8432 4.31641 19.578V12.578H20.3164V19.578ZM20.3164 10.578H4.31641V7.578C4.31641 7.31279 4.42176 7.05843 4.6093 6.8709C4.79684 6.68336 5.05119 6.578 5.31641 6.578H7.31641V7.578C7.31641 7.84322 7.42176 8.09757 7.6093 8.28511C7.79684 8.47265 8.05119 8.578 8.31641 8.578C8.58162 8.578 8.83598 8.47265 9.02351 8.28511C9.21105 8.09757 9.31641 7.84322 9.31641 7.578V6.578H15.3164V7.578C15.3164 7.84322 15.4218 8.09757 15.6093 8.28511C15.7968 8.47265 16.0512 8.578 16.3164 8.578C16.5816 8.578 16.836 8.47265 17.0235 8.28511C17.2111 8.09757 17.3164 7.84322 17.3164 7.578V6.578H19.3164C19.5816 6.578 19.836 6.68336 20.0235 6.8709C20.2111 7.05843 20.3164 7.31279 20.3164 7.578V10.578Z"
        fill={color}
      />
    </g>
  </svg>
);

// Tick Icon
export const Tick = ({ color = "#fff" }) => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.57776 9.642L15.2198 0L16.5 1.28025L5.57776 12.2025L0.499512 7.12575L1.77976 5.8455L5.57776 9.642Z"
      fill={color}
    />
  </svg>
);

// Arrowclockwise Icon
export const Arrowclockwise = ({ color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
    />
    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
  </svg>
);

// LinkedIn Icon
export const LinkedIn = ({ color = "#fff" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_741_5834)">
      <path
        d="M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z"
        fill="white"
      />
      <path
        d="M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z"
        fill="#0A66C2"
      />
      <path
        d="M11.5447 13.6053H13.3741C13.4404 13.6053 13.5039 13.579 13.5508 13.5321C13.5977 13.4852 13.624 13.4217 13.6241 13.3554L13.625 9.49025C13.625 7.47006 13.1897 5.91725 10.8289 5.91725C9.93144 5.88388 9.08512 6.3465 8.62844 7.119C8.6262 7.12275 8.62281 7.12567 8.61876 7.12731C8.61471 7.12895 8.61024 7.12922 8.60603 7.12808C8.60181 7.12694 8.59808 7.12445 8.59542 7.12099C8.59275 7.11754 8.59129 7.1133 8.59125 7.10894V6.35375C8.59125 6.28745 8.56491 6.22386 8.51803 6.17697C8.47114 6.13009 8.40755 6.10375 8.34125 6.10375H6.60519C6.53888 6.10375 6.4753 6.13009 6.42841 6.17697C6.38153 6.22386 6.35519 6.28745 6.35519 6.35375V13.355C6.35519 13.4213 6.38153 13.4849 6.42841 13.5318C6.4753 13.5787 6.53888 13.605 6.60519 13.605H8.43444C8.50074 13.605 8.56433 13.5787 8.61121 13.5318C8.6581 13.4849 8.68444 13.4213 8.68444 13.355V9.89419C8.68444 8.91563 8.87006 7.96794 10.0833 7.96794C11.2792 7.96794 11.2947 9.08769 11.2947 9.95756V13.3553C11.2947 13.4216 11.321 13.4852 11.3679 13.5321C11.4148 13.579 11.4784 13.6053 11.5447 13.6053ZM2.375 3.72675C2.375 4.46825 2.98544 5.07837 3.727 5.07837C4.46837 5.07831 5.07844 4.46781 5.07844 3.72644C5.07831 2.98506 4.46819 2.375 3.72675 2.375C2.98512 2.375 2.375 2.98525 2.375 3.72675ZM2.80994 13.6053H4.64162C4.70793 13.6053 4.77152 13.579 4.8184 13.5321C4.86529 13.4852 4.89162 13.4216 4.89162 13.3553V6.35375C4.89162 6.28745 4.86529 6.22386 4.8184 6.17697C4.77152 6.13009 4.70793 6.10375 4.64162 6.10375H2.80994C2.74363 6.10375 2.68004 6.13009 2.63316 6.17697C2.58628 6.22386 2.55994 6.28745 2.55994 6.35375V13.3553C2.55994 13.4216 2.58628 13.4852 2.63316 13.5321C2.68004 13.579 2.74363 13.6053 2.80994 13.6053Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_741_5834">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Google Icon
export const Google = ({ color = "#fff" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5396 6.69425H14.0026V6.66658H8.0026V9.33325H11.7703C11.2206 10.8856 9.7436 11.9999 8.0026 11.9999C5.7936 11.9999 4.0026 10.2089 4.0026 7.99992C4.0026 5.79092 5.7936 3.99992 8.0026 3.99992C9.02227 3.99992 9.94994 4.38458 10.6563 5.01292L12.5419 3.12725C11.3513 2.01759 9.7586 1.33325 8.0026 1.33325C4.32094 1.33325 1.33594 4.31825 1.33594 7.99992C1.33594 11.6816 4.32094 14.6666 8.0026 14.6666C11.6843 14.6666 14.6693 11.6816 14.6693 7.99992C14.6693 7.55292 14.6233 7.11658 14.5396 6.69425Z"
      fill="#FFC107"
    />
    <path
      d="M2.10156 4.89692L4.2919 6.50325C4.88456 5.03592 6.3199 3.99992 7.99956 3.99992C9.01923 3.99992 9.9469 4.38459 10.6532 5.01292L12.5389 3.12725C11.3482 2.01759 9.75556 1.33325 7.99956 1.33325C5.4389 1.33325 3.21823 2.77892 2.10156 4.89692Z"
      fill="#FF3D00"
    />
    <path
      d="M7.9975 14.6667C9.7195 14.6667 11.2842 14.0077 12.4672 12.936L10.4038 11.19C9.71213 11.7163 8.86669 12.0009 7.9975 12C6.2635 12 4.79117 10.8943 4.2365 9.35132L2.0625 11.0263C3.16583 13.1853 5.4065 14.6667 7.9975 14.6667Z"
      fill="#4CAF50"
    />
    <path
      d="M14.537 6.69441H14V6.66675H8V9.33342H11.7677C11.5047 10.0722 11.0311 10.7178 10.4053 11.1904L10.4063 11.1897L12.4697 12.9357C12.3237 13.0684 14.6667 11.3334 14.6667 8.00008C14.6667 7.55308 14.6207 7.11675 14.537 6.69441Z"
      fill="#1976D2"
    />
  </svg>
);

// Apple Icon
export const Apple = ({ color = "#fff" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_741_5858)">
      <path
        d="M12.2363 8.4856C12.258 10.8356 14.298 11.6177 14.3205 11.6277C14.3033 11.6827 13.9946 12.7422 13.2459 13.8364C12.5986 14.7824 11.9268 15.7249 10.8686 15.7446C9.82888 15.7636 9.4945 15.1279 8.30563 15.1279C7.11713 15.1279 6.74575 15.7249 5.76138 15.7636C4.73988 15.8024 3.962 14.7405 3.30938 13.7981C1.97588 11.8701 0.956752 8.34998 2.32513 5.97385C3.00488 4.79385 4.21988 4.04673 5.5385 4.02748C6.5415 4.00835 7.48825 4.70223 8.10138 4.70223C8.71413 4.70223 9.86463 3.86773 11.0741 3.99023C11.5805 4.01135 13.0018 4.19473 13.9144 5.53073C13.841 5.57635 12.2186 6.52085 12.2363 8.4856ZM10.2821 2.71485C10.8244 2.05848 11.1894 1.14448 11.0899 0.235352C10.3081 0.266727 9.36288 0.756226 8.80225 1.41235C8.29975 1.99323 7.85975 2.92323 7.97838 3.81435C8.84975 3.88185 9.73975 3.3716 10.2821 2.71485Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_741_5858">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// EnrollPlusButton Icon
export const EnrollPlusButton = ({ color = "#fff" }) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="40"
      height="40"
      rx="9.5"
      stroke="#404040"
      stroke-width="2"
    />
    <path
      d="M10.5 21L31.5 21"
      stroke="#404040"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 10.5L21 31.5"
      stroke="#404040"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
